<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import TasksCard from '../TasksCard/TasksCard.vue';

defineProps({
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  showButton: { type: Boolean, default: true },
  buttonLabel: { type: String, default: '' },
});

const emit = defineEmits(['create']);

const onClick = () => {
  emit('create');
};

// Sample data for empty state preview
const sampleTasks = [
  {
    id: 1,
    title: 'Follow up with Enterprise client',
    taskType: 'call',
    status: 'pending',
    priority: 'high',
    dueDate: new Date(Date.now() + 86400000).toISOString(),
    userName: 'John Smith',
    taskableName: 'Acme Corporation',
    updatedAt: new Date().toISOString(),
  },
  {
    id: 2,
    title: 'Send proposal email',
    taskType: 'email',
    status: 'in_progress',
    priority: 'medium',
    dueDate: new Date(Date.now() + 172800000).toISOString(),
    userName: 'Sarah Johnson',
    taskableName: 'TechStart Inc.',
    updatedAt: new Date(Date.now() - 86400000).toISOString(),
  },
  {
    id: 3,
    title: 'Weekly team meeting',
    taskType: 'meeting',
    status: 'completed',
    priority: 'low',
    dueDate: new Date(Date.now() - 86400000).toISOString(),
    userName: 'Mike Wilson',
    taskableName: 'Global Services Ltd.',
    updatedAt: new Date(Date.now() - 172800000).toISOString(),
  },
];
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <TasksCard
          v-for="task in sampleTasks"
          :key="task.id"
          :id="task.id"
          :title="task.title"
          :task-type="task.taskType"
          :status="task.status"
          :priority="task.priority"
          :due-date="task.dueDate"
          :user-name="task.userName"
          :taskable-name="task.taskableName"
          :updated-at="task.updatedAt"
        />
      </div>
    </template>
    <template #actions>
      <div v-if="showButton">
        <Button :label="buttonLabel" icon="i-lucide-plus" @click="onClick" />
      </div>
    </template>
  </EmptyStateLayout>
</template>
